module.exports = __webpack_public_path__ + "static/media/27_tn.465dd3ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/27_tn.jpg
// module id = 336
// module chunks = 0